// Register a jQuery Plugin
/// require('datatables.net-bs5');
import 'datatables.net-bs5';
//require( 'datatables.net-autofill-bs5' );
//global.$.fn.DataTable = require('datatables.net-dt');
//require( 'datatables.net-dt' )();
import * as pdfmake from "pdfmake-lite/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";
// pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as JSZip from "jszip";
window.JSZip = JSZip;
//require( 'datatables.net-buttons' );
/// require( 'datatables.net-buttons-bs5' );
import 'datatables.net-buttons-bs5';
//require( 'datatables.net-buttons-dt' );
/// require( 'datatables.net-buttons/js/buttons.colVis.js' );
/// require( 'datatables.net-buttons/js/buttons.html5.js' );
/// require( 'datatables.net-buttons/js/buttons.print.js' );
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
//require( 'datatables.net-colreorder-bs5' );
/// require( 'datatables.net-datetime' );
/// require( 'datatables.net-fixedcolumns-bs5' );
/// require( 'datatables.net-fixedheader-bs5' );
import 'datatables.net-datetime';
import 'datatables.net-fixedcolumns-bs5';
import 'datatables.net-fixedheader-bs5';
//require( 'datatables.net-keytable-bs5' );
/// require( 'datatables.net-responsive-bs5');
/// require( 'datatables.net-rowgroup-bs5' );
import 'datatables.net-responsive-bs5';
//import 'datatables.net-rowgroup-bs5';
//require( 'datatables.net-rowreorder-bs5' );
///require( 'datatables.net-scroller-bs5' );
import 'datatables.net-scroller-bs5';
//require( 'datatables.net-searchbuilder-bs5' );
//require( 'datatables.net-searchpanes-bs5' );
// require( 'datatables.net-select-bs5' );
// require( 'datatables.net-staterestore-bs5' );
import 'datatables.net-select-bs5';
import 'datatables.net-staterestore-bs5';
import './dtDateTime.js';

import { PdfAssetsLoader } from 'pdfmake-utils'

const assetsLoader = new PdfAssetsLoader()
pdfmake.fonts = assetsLoader.fonts
pdfmake.vfs = assetsLoader.vfs

// register Roboto font, normal variant. Roboto-Regular.woff must be in root path
assetsLoader.registerFont( {name: 'Roboto', fileName: 'Roboto-Regular.woff', URL: '/fonts/Roboto-Regular.woff', styles: ['normal']} )
// register Roboto font, bold variant. Roboto-Regular.woff must be in root path
assetsLoader.registerFont( {name: 'Roboto', fileName: 'Roboto-Bold.woff', URL: '/fonts/Roboto-Bold.woff', styles: ['bold']} )
// register Roboto font, bolditalics variant using a custom file location
assetsLoader.registerFont( {name: 'Roboto', fileName: 'Roboto-MediumItalic.woff', URL: '/fonts/Roboto-MediumItalic.woff', styles: ['bolditalics']} )

assetsLoader.load().then(() => {
  console.log('assets loaded')
}).catch(errors => {
  // errors -> array with all file loading errors
  console.error('assets loading', errors);
})

window.pdfmake = pdfmake;
